// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const VoidPaymentIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "VoidPayment/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M5.632 14.827c0 1.245.955 2.249 2.142 2.249h2.422c1.032 0 1.872-.879 1.872-1.96 0-1.176-.512-1.591-1.274-1.861l-3.889-1.351c-.762-.27-1.273-.685-1.273-1.863 0-1.08.839-1.958 1.871-1.958h2.422c1.187 0 2.143 1.003 2.143 2.248M8.843 6.79v11.578"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m16.053 1.688-2.895 1.375-4.053-1.376-3.811 1.375L1 1v22l4.294-2.063L9.105 23l4.053-2.063L17.21 23V12.632"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M21 8.944 17.037 5M20.963 5.056 17 9"
}));
export default VoidPaymentIcon;